module.exports = "pegasus/assets/circleline-google.gif";